module.exports = __webpack_public_path__ + "img/hohlschnitt_opalgruen_ral6026.80e6cef6.jpg";